var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete-Red"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.11499 21.75C6.56499 21.75 6.09416 21.5542 5.70249 21.1625C5.31082 20.7708 5.11499 20.3 5.11499 19.75V6.75H4.11499V4.75H9.11499V3.75H15.115V4.75H20.115V6.75H19.115V19.75C19.115 20.3 18.9192 20.7708 18.5275 21.1625C18.1358 21.5542 17.665 21.75 17.115 21.75H7.11499ZM17.115 6.75H7.11499V19.75H17.115V6.75ZM9.11499 17.75H11.115V8.75H9.11499V17.75ZM13.115 17.75H15.115V8.75H13.115V17.75Z",
    fill: "#EA3323"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.db251de2c2541590f6fecc8cdf59e7c0.svg";
export { ForwardRef as ReactComponent };